
import { FilterOperators } from "@crispico/foundation-gwt-js";
import { apolloClient, EntityDescriptor, EntityEditorFormSimple, FieldDescriptor, TestUtils, Utils } from "@crispico/foundation-react";
import { Filter } from "@crispico/foundation-react/components/CustomQuery/Filter";
import { DropdownExt, DropdownOption } from "@crispico/foundation-react/components/Dropdown/DropdownExt";
import { Wizard, WizardStep } from "@crispico/foundation-react/components/Wizard/Wizard";
import { entityDescriptors, ID } from "@crispico/foundation-react/entity_crud/entityCrudConstants";
import { FieldEditorProps, ManyToOneEditor } from "@crispico/foundation-react/entity_crud/fieldRenderersEditors";
import { dashboardEntityDescriptor } from "@crispico/foundation-react/FoundationEntityDescriptors";
import { FormikProps } from "formik/dist/types";
import React from "react";
import { Button, Grid, Icon, Segment } from "semantic-ui-react";
import { PopupWithHelpTooltip } from "../../../components/semanticUiReactExt";
import { COPY, MOVE } from "../DashboardContants";
import { DashboardWidgetFactories, DashboardWidgetType } from "../DashboardWidgetFactory";
import { DashboardTabProps } from "./DashboardTab";

export class DashboardWidgetWizard extends React.Component<DashboardTabProps> {

    entityEditorForm = React.createRef<EntityEditorFormSimple>();

    render() {
        const props = this.props;
        const dashboardType = props.dashboardEntity?.forEditor ? DashboardWidgetType.ENTITY : DashboardWidgetType.FILTER;
        const steps: WizardStep[] = [
            {
                title: _msg('Dashboard.widget.wizard.selectWidgetType'),
                icon: "question circle outline",
                nextDisabled: () => props.widgetActionOrType === undefined,
                render: () => {
                    let disabledWidgets: any = {}
                    Object.keys(props.widgetWrapperConfigs).forEach(w => {
                        if (!DashboardWidgetFactories.INSTANCE.widgets[props.widgetWrapperConfigs[w].type].allowMultiple) {
                            disabledWidgets[props.widgetWrapperConfigs[w].type] = true
                        }
                    })
                    return <Segment style={{ marginTop: '0px' }}><Grid style={{ padding: '0 10px' }} stackable columns='3'><Grid.Row>
                        <Grid.Column key={'move-copy'} stretched className='DashboardWizard_WidgetWrapper'>
                            <Segment>
                                <div className='DashboardWizard_MoveCopyWidget'>
                                    <Button className='DashboardWizard_MoveCopyWidgetButton' positive size='huge' onClick={() => props.dispatchers.selectWidgetType(COPY)}>{_msg('Dashboard.wizard.button.copy')}</Button>
                                    <p />
                                    <Button className='DashboardWizard_MoveCopyWidgetButton' primary size='huge' onClick={() => props.dispatchers.selectWidgetType(MOVE)}>{_msg('Dashboard.wizard.button.move')}</Button>
                                </div>
                            </Segment>
                        </Grid.Column>
                        {Object.keys(DashboardWidgetFactories.INSTANCE.widgets).map(type => {
                            const factory = DashboardWidgetFactories.INSTANCE.widgets[type];
                            if (factory.type !== DashboardWidgetType.ANY && factory.type !== dashboardType) {
                                return null
                            }
                            const info = factory.getWizardInfo()
                            const disabled = disabledWidgets[type] ? true : false
                            let widget = null
                            if (info.storybook && !TestUtils.storybookMode) {
                                return null
                            } else if (info.image) {
                                widget = <img style={{ objectFit: 'cover', width: '100%', height: '100%', }} src={info.image} alt='widgetImage' />
                            } else if (info.slice && info.component && info.testState) {
                                widget = TestUtils.wrapWithStoreForSlice(info.slice, info.component, info.testState, { frozenReducer: true, wrapInRouter: false, additionalProps: { zeroTrainingMode: true } })
                            } else if (info.component && info.testState) {
                                widget = <info.component {...info.testState} />
                            }
                            return <Grid.Column key={type} stretched className='DashboardWizard_WidgetWrapper'>
                                <Segment attached="top" className="flex-center flex-container-row less-padding" >
                                    <h4 className="flex-grow-shrink-no-overflow no-margin">{info.title}</h4>
                                    <div>
                                        <Button positive disabled={disabled} onClick={() => props.dispatchers.selectWidgetType(type)}><Icon name='add' />{_msg("general.add")}</Button>
                                        <PopupWithHelpTooltip tooltip={info.description} />
                                    </div>
                                </Segment>
                                <Segment secondary className={disabled ? " disabledItem" : undefined} style={{ height: '220px', padding: '5px', overflow: 'hidden' }} attached='bottom'>
                                    {widget}
                                </Segment>
                            </Grid.Column>
                        })}
                    </Grid.Row></Grid></Segment>
                }
            },
            {
                title: props.wizard.currentStepIndex == 1 && props.widgetActionOrType == COPY ? _msg('Dashboard.wizard.tab.copy') : props.widgetActionOrType == MOVE ? _msg('Dashboard.wizard.tab.move') : _msg('Dashboard.widget.wizard.configWidget'),
                icon: props.widgetActionOrType == COPY ? 'copy' : props.widgetActionOrType == MOVE ? 'arrow alternate circle right' : 'edit outline',
                render: () => {
                    if (props.widgetActionOrType === COPY || props.widgetActionOrType === MOVE) {
                        const additionalProps = props
                        return <EntityEditorFormSimple ref={this.entityEditorForm} hideButtonBar entity={{}}
                            entityDescriptor={new EntityDescriptor({ name: 'Dashboard.' + props.widgetActionOrType })
                                .addFieldDescriptor({ name: 'dashboard', type: 'Dashboard' }, new class extends FieldDescriptor {
                                    protected renderFieldEditorInternal(EditorClass: any, props: FieldEditorProps) {
                                        const newProps = { ...props, onChange: (e: any) => additionalProps.dispatchers.selectDashboard(e ? e.id : undefined), additionalProps: additionalProps }
                                        return React.createElement(DashboardManyToOneEditor as any, newProps as FieldEditorProps)
                                    }
                                }())
                                .addFieldDescriptor({ name: 'widgets', type: 'Widgets' }, new class extends FieldDescriptor {
                                    renderFieldEditor(formikProps: FormikProps<any>) {
                                        return <DropdownExt options={additionalProps.wizardCopyMoveWidgetsAll} selected={additionalProps.wizardCopyMoveWidgetsSelected} onChange={(selected: DropdownOption[]) => additionalProps.dispatchers.setInReduxState({ wizardCopyMoveWidgetsSelected: selected })} />
                                    }
                                }())
                            } />
                    } else {
                        return <EntityEditorFormSimple ref={this.entityEditorForm} hideButtonBar entity={{}}
                            entityDescriptor={DashboardWidgetFactories.INSTANCE.widgets[props.widgetActionOrType as string].getEntityDescriptor({}, props.dashboardEntity)}
                            onSubmitHandler={values => props.dispatchers.setInReduxState({ values: values })} />
                    }
                }
            }
        ];
        return <Wizard {...props.wizard} steps={steps} dispatchers={props.dispatchers.wizard}
            onCancelClick={() => props.dispatchers.onCancelClick()}
            onFinishClick={async () => {
                if (props.widgetActionOrType === COPY || props.widgetActionOrType === MOVE) {
                    if (props.wizardCopyMoveDashboardId && props.wizardCopyMoveWidgetsSelected.length > 0) {
                        if (props.widgetActionOrType === COPY) {
                            props.dispatchers.copyWidgets(props.dashboardEntity)
                        } else if (props.widgetActionOrType === MOVE) {
                            props.dispatchers.setInReduxState({ wizardMoveConfirmation: true });
                        }
                    }
                } else {
                    await this.entityEditorForm.current?.submit()
                    props.dispatchers.addItem({ dashboardEntity: props.dashboardEntity })
                }
            }} />
    }
}

class DashboardManyToOneEditor extends ManyToOneEditor<FieldEditorProps & { value?: any, placeholder?: any, onChange?: (entity: any) => void, additionalProps: DashboardTabProps }> {
    protected getInnerEntityDescriptor(): EntityDescriptor {
        return entityDescriptors['Dashboard'];
    }

    protected async performQuery(searchQuery: string) {
        const filter = Filter.create(ID, FilterOperators.forString.notEquals, (this.props.additionalProps.dashboardEntity.id).toString())
        let params = this.props.additionalProps.widgetActionOrType == COPY ? this.createFindByStringParams(searchQuery) : this.createFindByStringParams(searchQuery).filter(filter)
        return (await apolloClient.query({ query: this.query, variables: params })).data[this.operationName];
    }

    render() {
        return <div className='flex-container-row'>
            <div className='flex-grow-shrink-no-overflow' style={{ paddingRight: '10px' }}>
                {super.render()}
            </div>
            <Button disabled={!this.props.additionalProps.wizardCopyMoveDashboardId} onClick={() => window.open(Utils.adjustUrlToServerContext('#' + dashboardEntityDescriptor.getEntityEditorUrl(this.props.additionalProps.wizardCopyMoveDashboardId) + '/dashboard'), '_blank')}>{_msg('Dashboard.wizard.newTab')}</Button>
        </div>
    }
}